import React, { DetailedHTMLProps, useMemo } from "react"
import { TextInput } from "./TextInput"


const PasswordInput = React.forwardRef<HTMLInputElement, Props>( ( { ...props }, ref ) => {

    const className = useMemo( () => {
        return [
            '',
            ...( props.className?.split( ' ' ) ?? [] )
        ].join( ' ' )
    }, [ props ] )

    return (
        <TextInput
            ref={ ref }
            { ...props }
            className={ className }
            type="password"
        />
    )
})

interface Props extends DetailedHTMLProps<any, HTMLInputElement> {

}

export { PasswordInput }
